export default __webpack_public_path__ + "static/media/PC-PDF.bbb7e903.png";